import { render, staticRenderFns } from "./BusinessUnits.vue?vue&type=template&id=ea98f428&scoped=true&"
import script from "./BusinessUnits.vue?vue&type=script&lang=js&"
export * from "./BusinessUnits.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnits.vue?vue&type=style&index=0&id=ea98f428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea98f428",
  null
  
)

export default component.exports